(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5374],{

/***/ 78499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/snippets/poshmark-cancel-sale/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2021-07-08",
      tag: "Poshmark Snippets",
      title: "How to Cancel an Order on Poshmark",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you haven't shipped an item yet, it's still possible to cancel an order before it's sent out! Here's how to do it:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "On Desktop / Laptop"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click on your profile picture at the top right "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click on \"My Sales\""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select the order you want to cancel"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click on \"Problems/Order Inquiry\""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click on \"Cancel Order\""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select a reason for the cancellation then hit submit"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "In the Poshmark App:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to your accounts page(@account_name). It should be on the bottom right"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Scroll down to \"My Sales\""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select the order you wish to cancel"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select Problems/Order Inquiry"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select Cancel Order and enter in a reason for the cancellation"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: " Best of luck, and happy selling!"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/poshmark-cancel-sale.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "How to Cancel an Order on Poshmark | OneShop Blog"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "If you haven\u2019t shipped an item yet, it\u2019s still possible to cancel an order before it\u2019s sent out! Here\u2019s how to do it."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/poshmark-cancel-sale"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/poshmark-cancel-sale"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "How to Cancel an Order on Poshmark | OneShop Blog"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "If you haven\u2019t shipped an item yet, it\u2019s still possible to cancel an order before it\u2019s sent out! Here\u2019s how to do it."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2021-07-08T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2021-07-08T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 17461:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/poshmark-cancel-sale",
      function () {
        return __webpack_require__(78499);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(17461); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);